export const datePicker = {
  calenderIcon: {
    alt: 'Abrir calendário'
  },
  clearIcon: {
    alt: 'Apagar a data'
  }
};
